import React, { useEffect, useState } from "react";
import style from "./styles.module.scss";
import {
  getPieChartData,
  getTransactionCardSummaryChartData,
} from "../../../../../../api";
import useMerchantStore from "../../../../../stores/merchant";
import useCommonStore from "../../../../../stores/common";
import DoubleDonutChart from "./DoubleDonutChart";
import { backgroundColors } from "./utils/backgroundColors";
import moment from "moment";
import SkeletonLoader from "../../../../../components/skeleton-loader";

// Card image mapping
const CARD_IMAGES = {
  Visa: "/images/visa24x24.svg",
  Mastercard: "/images/master24x24.svg",
  Amex: "/images/amex24x24.svg",
  Discover: "/images/discover24x24.svg",
  Debit: "/images/debit24x24.svg",
  EBT: "/images/ebt24x24.svg",
  MC: "/images/master24x24.svg",
  VS: "/images/visa24x24.svg",
  VD: "/images/visa24x24.svg",
  DS: "/images/discover24x24.svg",
  MD: "/images/debit24x24.svg",
  AM: "/images/amex24x24.svg",
  VB: "/images/visa24x24.svg",
  DD: "/images/ebt24x24.svg",
  MB: "/images/master24x24.svg",
};

const CardComparisonChart = () => {
  const activeApp = useMerchantStore((state) => state.activeApp);
  const dateRange = useCommonStore((state) => state.dateRange);
  const [isLoading, setIsLoading] = useState(true);
  const [labels, setLabels] = useState([]);
  const [innerData, setInnerData] = useState([]);
  const [outerData, setOuterData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (!activeApp?.id) return;

      try {
        setIsLoading(true);

        const end = dateRange?.endDate ? moment(dateRange.endDate) : moment();
        const start = dateRange?.startDate
          ? moment(dateRange.startDate)
          : moment(end).subtract(12, "months");

        const response = await getTransactionCardSummaryChartData({
          mid: activeApp?.power_app_submission?.mid,
          start_date: start.format("YYYY-MM-DD"),
          end_date: end.format("YYYY-MM-DD"),
        });

        if (response.status) {
          // const cardTypes = response.data.cardTypes || [];
          // const validCardTypes = cardTypes.filter(card => card.name && (card.amount > 0 || card.count > 0));

          // setLabels(validCardTypes.map(card => card.name));
          // setInnerData(validCardTypes.map(card => card.amount || 0));
          // setOuterData(validCardTypes.map(card => card.count || 0));

          setLabels(response.data.labels);
          setInnerData(response.data.innerData);
          setOuterData(response.data.outerData);
        }
      } catch (error) {
        console.error("Error fetching pie chart data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [activeApp?.id, dateRange]);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <SkeletonLoader variant="circular" width="320px" height="320px" />
      </div>
    );
  }

  if (!labels.length) {
    return <div className={style.noData}>No transaction data available</div>;
  }

  return (
    <div>
      <div className={style.donut_chart}>
        <DoubleDonutChart
          labels={labels}
          innerData={innerData}
          outerData={outerData}
        />
      </div>
      <div className={style.cardLabels}>
        {labels.map((label, index) => {
          const cardImage = CARD_IMAGES[label] || null;
          return (
            <div key={index} className={style.cardComparisonItem}>
              <div className={style.cardInfo}>
                <div
                  className={style.colorDot}
                  style={{ backgroundColor: backgroundColors[index] }}
                ></div>
                {cardImage && (
                  <img src={cardImage} alt={label} className={style.cardIcon} />
                )}
                <span className={style.cardLabel}>{label}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CardComparisonChart;
